import { Box, Card, Grid, Divider, Typography } from '@mui/material';
import React from 'react';

const VendorComp = ({ userDetails, heading }) => {
    return (
        <Box sx={ { width: '100%', maxWidth: '100%', margin: 'auto', mt: 4 } }>
            <Typography variant="h5" sx={ { mb: 2, fontWeight: 'bold', textAlign: 'start' } }>
                { heading }
            </Typography>
            <Card sx={ { p: 3, background: '#f5f5f5', borderRadius: 0, boxShadow: 3 } }>
                <Grid container spacing={ 2 }>
                    { userDetails.map(({ label, value }, index) => (
                        <React.Fragment key={ index }>
                            <Grid item xs={ 12 } sm={ 6 }>
                                <Box sx={ { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } }>
                                    <Typography variant="body1" >
                                        { label }
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        { value }
                                    </Typography>
                                </Box>
                            </Grid>
                            { index % 2 !== 0 && index !== userDetails.length - 1 && (
                                <Grid item xs={ 12 }>
                                    <Divider />
                                </Grid>
                            ) }
                        </React.Fragment>
                    )) }
                </Grid>
            </Card>
        </Box>
    );
};

export default VendorComp;
